
import { Component, Vue, Watch } from 'vue-property-decorator';
import { getHomeSingleRank, getHomeScreenInfo } from '@/apis/index';
import { allReportSelect, screenGrade } from '@/config/config';

type selectType = {
  name: string;
  select: boolean;
  value: string;
};

type buttonType = {
  name: string;
  select?: boolean;
  value?: string;
  children: selectType[];
};

type queryInterface = {
  cat: string;
  industry_id: string;
  author_id: string;
  org_id: string;
  rating: string;
};

@Component
export default class AllScreen extends Vue {
  // 获取选择项头部信息
  headList = allReportSelect();
  // 是否展示蒙层
  isShowMask = false;

  // 用来请求的接口对象
  queryInfo: queryInterface = {
    cat: '',
    industry_id: '',
    author_id: '',
    org_id: '',
    rating: '',
  };
  // 所有的选项信息 研报类型 行业类型 机构/分析师 评级
  allContentData: buttonType[][] = [
    [],
    [],
    [],
    screenGrade.map(item => ({
      ...item,
      select: false,
      children: [],
    })),
  ];
  // 当前展示的选项内容
  contentData: buttonType[] = [];
  // 激活的选择索引
  activeIndex = 0;
  // 选项的类型 select选择按钮 button按钮激活
  contentType = '';
  @Watch('activeIndex', { immediate: false })
  activeIndexChange(newVal: number, olbVal: number) {
    // 更改激活状态
    this.headList[newVal].isActive = true;
    this.headList[olbVal].isActive = false;
    // 更改选择的状态
    this.headList[olbVal].isSelected = this.getHeadSelect(
      this.allContentData[olbVal],
      this.headList[olbVal].type
    );
  }
  @Watch('isShowMask', { immediate: false })
  isShowMaskChange(newVal: boolean) {
    if (!newVal) {
      // 关闭蒙层的时候 选择状态要更新 并且获取请求体对象
      document.body.style.overflow = '';
      this.headList[this.activeIndex].isSelected = this.getHeadSelect(this.allContentData[this.activeIndex]);
    }
  }
  get isNeedReset() {
    // 按钮透明度
    return this.headList[this.activeIndex].isSelected;
  }
  headClick(index: number) {
    window.hxmClickStat(this.headList[index].stat);
    // 选择信息状态变更 当前是否激活
    const flag = !this.headList[index].isActive;
    // 更改激活状态
    this.headList[index].isActive = flag;
    // 更改蒙层的状态
    this.isShowMask = flag;
    if (flag) {
      // 如果是打开的 更改激活的索引
      this.activeIndex = index;
      // 更改对应的内容类型 进行渲染
      this.contentType = this.headList[index].type;
      // 获取展示的内容
      this.contentData = JSON.parse(JSON.stringify(this.allContentData[index]));
      document.body.style.overflow = 'hidden';
    }
  }
  selectItem(index: number) {
    // 选择 选择类型
    const flag = !this.contentData[index].select;
    this.contentData[index].select = flag;
    this.headList[this.activeIndex].isSelected = this.getHeadSelect(this.contentData);
  }
  buttonItem(index: number, inner: number) {
    // 选择 按钮类型
    const flag = !this.contentData[index].children[inner].select;
    this.contentData[index].children[inner].select = flag;
    this.headList[this.activeIndex].isSelected = this.getHeadSelect(this.contentData);
  }
  closeMask() {
    // 关闭蒙层
    this.headList[this.activeIndex].isActive = false;
    document.body.style.overflow = '';
    this.isShowMask = false;
  }
  getHeadSelect(data: buttonType[], type?: string): boolean {
    // 获取当前的数据是否有选择信息
    const tempType = type || this.contentType;
    if (tempType === 'select') {
      // 选择类型处理
      return !!data.find(item => item.select);
    } else if (tempType === 'button') {
      // 按钮类型处理
      return !!data.find(item => item.children.find(child => child.select));
    } else {
      return false;
    }
  }
  resetInfo() {
    if (this.contentType === 'select') {
      // 选择类型重制
      this.contentData = this.contentData.map(item => {
        item.select = false;
        return item;
      });
    }
    if (this.contentType === 'button') {
      // 按钮类型重制
      this.contentData = this.contentData.map(item => {
        item.children = item.children.map(child => {
          child.select = false;
          return child;
        });
        return item;
      });
    }
    this.allContentData[this.activeIndex] = this.contentData;
    // 清楚头部的选择状态 并且关闭
    this.headList[this.activeIndex].isSelected = false;
    this.headList[this.activeIndex].isActive = false;
    this.isShowMask = false;
    if (JSON.stringify(this.queryInfo) === JSON.stringify(this.getQuery())) {
      return;
    }
    this.$emit('reset', this.queryInfo);
  }
  getSelectInfo() {
    getHomeSingleRank({
      con: 'search',
      act: 'getSearchType',
    }).then(res => {
      if (res.data) {
        const reportType = res.data.reportType.map((item: any) => ({
          ...item,
          select: false,
          value: item.code,
        }));
        const reprotCategory = res.data.reprotCategory.map((item: any) => {
          item.children = item.children.map((child: any) => ({
            ...child,
            select: window.getParam('industryId') === child.id,
            value: child.id,
          }));
          return item;
        });
        if (window.getParam('industryId')) {
          this.headList[1].isSelected = this.getHeadSelect(reprotCategory, 'button');
          this.queryInfo.industry_id = window.getParam('industryId');
        }
        this.$set(this.allContentData, 0, reportType);
        this.$set(this.allContentData, 1, reprotCategory);
      }
    });
  }
  async getData() {
    this.getSelectInfo();
    let hotAuthor: selectType[] = [];
    await getHomeSingleRank({
      con: 'author',
      act: 'hotAuthor',
    }).then(res => {
      if (res.statusCode === 0 && res.data && res.data.length) {
        hotAuthor = res.data.map((item: any) => this.formatAuthor(item));
      }
    });
    await getHomeScreenInfo({}).then(res => {
      if (res.statusCode === 0 && res.data) {
        const agencyInfo = [
          {
            name: '我关注的分析师',
            children: res.data.followAuthorList.map((item: any) => this.formatAuthor(item)),
          },
          {
            name: '我关注的机构',
            children: res.data.followOrgList.map((item: any) => this.formatOrg(item)),
          },
          {
            name: '热门分析师',
            children: hotAuthor,
          },
          {
            name: '热门机构',
            children: res.data.hotOrgList.map((item: any) => this.formatOrg(item)),
          },
        ];
        this.$set(this.allContentData, 2, agencyInfo);
      }
    });
  }
  formatOrg(item) {
    return {
      ...item,
      select: false,
      value: item.orgId,
      name: item.org,
    };
  }
  formatAuthor(item) {
    return {
      ...item,
      select: false,
      value: item.authorId,
      name: item.author,
    };
  }
  getValue(index: number): string {
    const arr: string[] = [];
    // 获取选择的信息的value信息
    this.allContentData[index].forEach(item => {
      if (this.contentType === 'select' && item.select) {
        arr.push(item.value || '');
      }
      if (this.contentType === 'button') {
        item.children.forEach(child => {
          child.select && arr.push(child.value);
        });
      }
    });
    return arr.join(',');
  }
  getQuery() {
    const index = this.activeIndex;
    const info = this.getValue(index);

    // 用来请求的接口对象
    const { queryInfo } = this;
    const keyArr = ['cat', 'industry_id', 'author_id', 'rating'];
    if (index === 2) {
      // 针对机构和分析师做处理
      const infoArr: string[][] = [[], []];
      this.allContentData[index].forEach((item, inn) => {
        item.children.forEach(child => {
          if (child.select) {
            infoArr[inn % 2].push(child.value);
          }
        });
      });
      queryInfo.author_id = infoArr[0].join(',');
      queryInfo.org_id = infoArr[1].join(',');
    } else {
      // 其他情况
      queryInfo[keyArr[index] as keyof queryInterface] = info;
    }
    return queryInfo;
  }
  sureInfo() {
    this.allContentData[this.activeIndex] = this.contentData;
    this.headList[this.activeIndex].isActive = false;
    this.isShowMask = false;
    if (JSON.stringify(this.queryInfo) === JSON.stringify(this.getQuery())) {
      return;
    }
    this.$emit('selected', this.queryInfo);
  }
  mounted() {
    this.getData();
  }
}
